import { type V2_MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import { Icon } from "app/components/ui/icon.tsx";


export const meta: V2_MetaFunction = () => {
  return [
    { title: 'Legal notice - Tilch.dev' },
    { name: 'robots', content: 'noindex, nofollow' },
  ]
}

export default function LegalNotice() {

  return <>
    <h1 className="text-4xl font-serif mb-4 decoration-amber-400 decoration-4 underline-offset-4 underline">Legal notice</h1>
    <p>Sebastian Tilch <br />
      Kautschukstr. 21 <br />
      50733 Cologne <br />
      Germany <br /><br />
      <span className="flex flex-row-reverse justify-end"><span>gmail.com</span><span>@</span><span>seb.tilch+legalnotice</span></span>
    </p><br />
    <Link
      to="/contact" >
      <Icon
        name="envelope-closed">
        <span
          className="underline"
        >
          Contact
        </span>
      </Icon>
    </Link>
    <h2 className="mt-4 font-bold mb-2">Privacy Policy</h2>

    <h3 className="font-medium mt-2" >Functional Cookies</h3>
    <ul className="list-disc list-inside">
      <li>Preferred theme (dark or light) in order to avoid a content flash</li>
      <li>The time zone to render date and time correctly on the server side</li>
    </ul>
    <h3 className="font-medium mt-2">Session Storage</h3>
    <ul className="list-disc list-inside">
      <li>Scroll position to restore the scroll position after navigating</li>
    </ul>

    <h3 className="font-medium mt-2">Hosting</h3>
    <p>This website is hosted by fly.io</p>
    <address>Fly.io, Inc.
      2045 West Grand Avenue Ste B
      Chicago, IL 60612</address>


    <h3 className="font-medium mt-2">Analytics</h3>
    <p>To get an idea of how many users visit this site and which post resonates, I use Cloudflare Web Analytics</p>
    <address>Cloudflare Germany GmbH
      Rosental 7, c/o Mindspace
      80331 München</address>
    (see <a className="underline" href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer">privacy policy</a> )

    <h3 className="font-medium mt-2">Mail Service</h3>
    <p>I am using resend.com to send mail (see <a className="underline" href="https://resend.com/legal/privacy-policy" target="_blank" rel="noreferrer">privacy policy</a> )</p>
    <address>2261 Market Street #5039 San Francisco, CA 94114</address>
    <p>To determine whether you have already sent me an email with this email address, I store a SHA-256 hash of it.</p>


  </>
}


